import { Component, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagingService } from '../components/messaging/messaging.service';
import { AuthService } from '../auth/auth.service';
import { ResetPasswordPayload } from '../model/user.model';
import { InfoMessageComponent } from '../components/info-message/info-message.component';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { BrowserAutoFillDisabledDirective } from '../directives/browser-auto-fill-disabled.directive';
import { MatButton } from '@angular/material/button';
import { StaticFooterComponent } from '../static-footer/static-footer.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  imports: [
    InfoMessageComponent,
    MatToolbar,
    MatToolbarRow,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatIcon,
    MatInput,
    BrowserAutoFillDisabledDirective,
    MatError,
    MatButton,
    StaticFooterComponent
  ]
})
export class ResetPasswordComponent implements OnInit {
  resetForm: UntypedFormGroup;
  usernameParam: string;
  submitPending = signal<boolean>(false);
  reset = signal<boolean>(false);

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private messagingService: MessagingService
  ) {}

  get username() {
    return this.resetForm.get('username');
  }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams) {
      this.usernameParam = this.route.snapshot.queryParams.username;
    }

    this.resetForm = this.formBuilder.group({
      username: ['', [Validators.required]]
    });

    this.username.setValue(this.usernameParam ? this.usernameParam : '');
  }

  backToLogin() {
    this.router.navigate(['login']);
  }

  resetPassword() {
    this.username.disable();
    this.submitPending.set(true);
    const resetPass: ResetPasswordPayload = {
      username: this.username.value
    };
    this.auth.reset(resetPass).subscribe({
      next: () => this.reset.set(true),
      error: () => {
        this.messagingService.error('There was a problem resetting your password. Please try again');
        this.submitPending.set(false);
        this.username.enable();
      }
    });
  }
}
